import { FilterSortBar } from "../../../components/filterSortBar/FilterSortBar";
import { MapButton } from "./MapButton";
import classNames from "classnames";
import PropTypes from "prop-types";
import "./ActionBarDesktop.scss";

export const ActionBarDesktop = ({
	isSticky = false,
	showMapButton = false,
	isLoading = true,
	isSortAvailable = true,
	onSubmit,
	onFilterOpen,
	onFilterSubmit,
	onSortSubmit,
	onSortOpen,
	onMapClick,
	className,
	...props
}) => {
	const actionBarClassName = classNames("action-bar-desktop", {
		"action-bar-desktop--sticky": isSticky,
		[className]: className,
	});

	return (
		<div className={actionBarClassName}>
			<FilterSortBar
				isLoading={isLoading}
				isSortAvailable={isSortAvailable}
				onSubmit={onSubmit}
				onFilterOpen={onFilterOpen}
				onFilterSubmit={onFilterSubmit}
				onSortSubmit={onSortSubmit}
				onSortOpen={onSortOpen}
				{...props}
			/>

			{showMapButton && <MapButton onClick={onMapClick} isLoading={isLoading} />}
		</div>
	);
};

ActionBarDesktop.propTypes = {
	className: PropTypes.string,
	isSticky: PropTypes.bool,
	showMapButton: PropTypes.bool,
	isLoading: PropTypes.bool,
	isSortAvailable: PropTypes.bool,
	onSubmit: PropTypes.func,
	onFilterOpen: PropTypes.func,
	onFilterSubmit: PropTypes.func,
	onSortSubmit: PropTypes.func,
	onSortOpen: PropTypes.func,
	onMapClick: PropTypes.func,
};
